import type { QuestionProps } from '../eform.types'
import { readApproval } from '../eformAnswers'

/**
 * A review with an "approved for public posting" box. The answer is
 * [text, '1' | '0']: the text and the box travel separately, and the submit
 * sends them as `value` and `approved` (toSubmitAnswers, R16).
 */
export default function TextareaApproval({ value, onChange, error }: QuestionProps) {
  const { text: displayText, approved } = readApproval(value)

  function handleTextChange(text: string) {
    onChange([text, approved ? '1' : '0'])
  }

  function handleApprovalChange(checked: boolean) {
    onChange([displayText, checked ? '1' : '0'])
  }

  return (
    <div className="space-y-3">
      <textarea
        value={displayText}
        onChange={(e) => handleTextChange(e.target.value)}
        placeholder="Your response"
        rows={4}
        className={`w-full rounded-lg border px-4 py-3 text-sm resize-y transition-colors focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary ${
          error ? 'border-red-300' : 'border-slate-200'
        }`}
      />
      <label className="flex items-start gap-3 cursor-pointer">
        <input
          type="checkbox"
          checked={approved}
          onChange={(e) => handleApprovalChange(e.target.checked)}
          className="mt-0.5 h-4 w-4 rounded border-slate-300 text-primary focus:ring-primary"
        />
        <span className="text-sm text-slate-600">
          This review is approved for public posting by the practice.
        </span>
      </label>
      {error && <p className="text-sm text-red-500 mt-1">{error}</p>}
    </div>
  )
}
